import axios from "axios";
import { ArrowUpDown, RefreshCw } from "lucide-react";
import { useState, useEffect } from "react";

export const AgentBalanceCard = ({ entityId, title }) => {
  const [walletData, setWalletData] = useState({
    balance: 0,
    currency: "₹",
    isLoading: true,
    lastUpdated: null,
    transactions: [],
  });
  const [isRefreshing, setIsRefreshing] = useState(false);

  const fetchWalletBalance = async () => {
    try {
      setIsRefreshing(true);
      if (!entityId) {
        console.error("No entityId provided");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/wallet/${entityId}`
      );

      if (response.data.success) {
        setWalletData({
          balance: response.data.balance,
          currency: response.data.currency === "INR" ? "₹" : "$",
          isLoading: false,
          lastUpdated: new Date(response.data.lastUpdated),
          transactions: response.data.transactions || [],
        });
      }
    } catch (err) {
      console.error("Error fetching wallet balance:", err);
      setWalletData((prev) => ({
        ...prev,
        isLoading: false,
      }));
    } finally {
      setIsRefreshing(false);
    }
  };

  useEffect(() => {
    if (entityId) {
      fetchWalletBalance();
    }
  }, [entityId]);

  const formatBalance = (balance) => {
    if (walletData.currency === "₹") {
      return `${walletData.currency} ${parseFloat(balance).toLocaleString(
        "en-IN"
      )}`;
    }
    return `${walletData.currency}${parseFloat(balance).toLocaleString()}`;
  };

  const formatTimeSinceUpdate = (date) => {
    if (!date) return "just now";

    const seconds = Math.floor((new Date() - new Date(date)) / 1000);

    if (seconds < 60) return "just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)} mins ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)} hours ago`;
    return `${Math.floor(seconds / 86400)} days ago`;
  };

  useEffect(() => {
    const interval = setInterval(() => {
      formatTimeSinceUpdate();
    }, 60000); // 60 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 rounded-2xl p-6 text-white shadow-lg mb-6">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm opacity-80">{title} Balance</p>
          <h2 className="text-3xl font-bold mt-1">
            {walletData.isLoading
              ? "Loading..."
              : formatBalance(walletData.balance)}
          </h2>
          <p className="text-xs opacity-80 mt-2">
            Last updated {formatTimeSinceUpdate(walletData.lastUpdated)}
          </p>
        </div>
        <button
          onClick={fetchWalletBalance}
          disabled={isRefreshing}
          className="bg-white/20 hover:bg-white/30 p-2 rounded-lg transition disabled:opacity-50"
        >
          {isRefreshing ? (
            <RefreshCw className="h-5 w-5 animate-spin" />
          ) : (
            <ArrowUpDown className="h-5 w-5" />
          )}
        </button>
      </div>
    </div>
  );
};